import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Route, Redirect, Switch } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import ContentArea from "./components/ContentArea";
import PageLoader from "./components/PageLoader";
import adminPages from "./adminPages";
import prepareMemberRoutes from "./utils/prepareMemberRoutes";
import logoutUtil from "./utils/logout";
import { loadUserProfile } from "./api";
import ServerErrorPage from "./components/ServerErrorPage";
import NoAssignedDashboard from "./components/NoAssignedDashboard";
import { getClientView } from "./utils/clientView";

const isClientView = getClientView();

const App = () => {
  const [loading, setLoading] = useState(null);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const req = async () => {
      setLoading(true);
      try {
        const resp = await loadUserProfile();
        if (resp.status === 401) {
          return setTimeout(logoutUtil, 100);
        }
        const { data } = await resp.json();
        setUser(data);
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    req();
  }, []);

  if (error) {
    return <ServerErrorPage />;
  } else if (loading || !user) {
    return <PageLoader />;
  }

  const showClientView = (user && user.role === "operator") || isClientView;

  const pages = showClientView ? prepareMemberRoutes(user.sidebar) : adminPages;

  return (
    <div>
      <Sidebar
        user={user}
        pages={user.role === "operator" || isClientView ? pages : adminPages}
      />
      <ContentArea>
        {!user.sidebar.length & showClientView ? (
          <NoAssignedDashboard />
        ) : (
          <Switch>
            {pages.map(
              ({ path, id, component: PageComponent, embedUrl, banner }) => (
                <Route
                  key={path}
                  exact
                  path={path}
                  render={props => (
                    <PageComponent
                      user={user}
                      {...props}
                      id={id}
                      embedUrl={embedUrl}
                      banner={banner}
                    />
                  )}
                />
              )
            )}
            <Route
              render={() => (
                <Redirect
                  to={
                    user.role === "operator" || isClientView
                      ? pages[0].to
                      : adminPages[0].to
                  }
                />
              )}
            />
          </Switch>
        )}
      </ContentArea>
    </div>
  );
};

App.propTypes = {
  role: PropTypes.string
};

export default App;
